export default class TabbarItem{
	constructor({id = '', icon = '', label = '', dot = '', badge = 0, path = '', handler}) {
		this.id = id
	    this.icon = icon
		this.label = label
		this.dot = dot
		this.badge = badge
		this.path = path
		this.handler = handler
	}
}